export const hireDataScientestPageContent = {

    // HirePageBanner Content (from "Hire Data Scientists & Engineers" intro)
    mainBanner: {
        shortHeading: "For Efficient Data Workflows and Actionable Insights",
        mainHeading: "Build scalable, reliable <span>Data Science</span> solutions with engineers trusted by 50+ global organizations.",
        content: "Need a proven Data Science partner? Our Data Scientists and Engineers help businesses automate data workflows, increase data accuracy by up to 35%, and optimize cloud data infrastructure to improve performance by 30%. Partner with us to implement advanced data pipelines, cut model deployment time by 40%, and streamline data operations to enhance real-time decision-making.",
    },

    // HirePageExperties Content (from "Our Core Data Science & Engineering Expertise")
    flutterExpertise: {
        btnText: "Connect with Our Data Experts Today",
        shortHeading: "Our Core Data Science & Engineering Expertise",
        heading: "We deliver enterprise-grade data solutions that help organizations leverage, interpret, and act on their most valuable asset data.",
        description: "Our experts provide comprehensive data science and engineering capabilities, transforming raw information into measurable business value and strategic insights.",
        servicesData: [
            {
                title: "Data Analytics & Business Intelligence",
                description:
                    "Turn data into actionable insights. We build dashboards, KPIs, and visualization systems using tools like Power BI and Tableau, enabling data-driven decision-making at every level of your organization.",
                icon: "/images/hire-page-icons/flutter-icon-1.svg", // Placeholder, original icon names kept
            },
            {
                title: "Big Data Engineering",
                description:
                    "We design and manage scalable data pipelines using Spark, Hadoop, and Kafka, ensuring fast, secure, and efficient data processing at scale, powering your big data initiatives.",
                icon: "/images/hire-page-icons/flutter-icon-2.svg", // Placeholder, original icon names kept
            },
            {
                title: "Predictive Analytics",
                description:
                    "Using machine learning algorithms and statistical models, we predict customer behavior, optimize processes, and reduce operational risks, helping you stay ahead of market trends.",
                icon: "/images/hire-page-icons/flutter-icon-3.svg", // Placeholder, original icon names kept
            },
            {
                title: "Data Warehousing & ETL Development",
                description:
                    "We develop and automate ETL workflows to consolidate data from multiple sources, ensuring clean, consistent, and accessible data for analytics that drive business performance.",
                icon: "/images/hire-page-icons/flutter-icon-4.svg", // Placeholder, original icon names kept
            },
            {
                title: "Cloud Data Solutions",
                description:
                    "Deploy data systems on AWS, Azure, or Google Cloud, with auto-scaling, redundancy, and cost-efficient storage, ensuring your data systems are both flexible and scalable.",
                icon: "/images/hire-page-icons/flutter-icon-5.svg", // Placeholder, original icon names kept
            },
            {
                title: "Data Governance & Quality Management",
                description:
                    "We implement validation, standardization, and governance policies to ensure that your data remains accurate, secure, and compliant with industry standards.",
                icon: "/images/hire-page-icons/flutter-icon-6.svg", // Placeholder, original icon names kept
            },
            {
                title: "AI-Powered Automation",
                description:
                    "Integrate artificial intelligence into your data workflows, automating reporting, anomaly detection, and trend forecasting, to improve operational efficiency and decision-making.",
                icon: "/images/hire-page-icons/flutter-icon-7.svg", // Placeholder, original icon names kept
            },
            {
                title: "Data Visualization & Reporting",
                description:
                    "Create custom visual dashboards that translate complex data into meaningful insights, enabling faster decision-making and driving business intelligence.",
                icon: "/images/hire-page-icons/flutter-icon-8.svg", // Placeholder, original icon names kept
            },
            {
                title: "Advanced Statistical Modeling",
                description:
                    "Our experts use Python, R, and SQL to build complex models for forecasting, optimization, and performance tracking, providing you with the tools to make data-backed decisions with confidence.",
                icon: "/images/hire-page-icons/flutter-icon-1.svg", // Placeholder, original icon names kept
            },
        ]
    },

    // Testimonials Data (from "Trusted Partnerships. Proven Data Excellence")
    testimonialsData: [
        {
            name: "Ethan Carter",
            enterprise: "Financial Analytics",
            country: "New York, US",
            profileImage: "/images/testimonials/michael.avif", // Placeholder, original image names kept
            logoImage: "/images/logo-2.png", // Placeholder, original image names kept
            countryFlagImage: "/images/testimonials/flags/usa-flag.png", // Placeholder, original image names kept
            designation: "CTO at FinEdge Analytics",
            feedback:
                "The team built an advanced data warehouse and predictive model that helped us identify revenue opportunities we were missing before. The improvements in accuracy and efficiency were outstanding.",
            serviceTags: ["Financial Analytics"]
        },
        {
            name: "Sarah Mitchell",
            enterprise: "Healthcare Data Management",
            country: "Boston, US",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png", // Placeholder, original image names kept
            designation: "Head of Operations at Medinova Health",
            profileImage: "/images/testimonials/sophie.avif", // Placeholder, original image names kept
            logoImage: "/images/logo-2.png", // Placeholder, original image names kept
            feedback: "The engineers restructured our data pipelines and integrated real-time dashboards, reducing reporting times by 60%. We now make faster, data-backed operational decisions.",
            serviceTags: ["Healthcare Data Management"]
        },
    ],

    ctaSection: {
        mainHeading: "Need Experts Who Can Turn Your Data Into Real Business Value?",
        description: "Hire skilled data scientists who transform unstructured data into clear, data-driven strategies that boost performance, accuracy, and decision-making.",
        btnText: "Hire a Data Scientist Today",
        btnLink: "/contact-us",
    },

    // DevelopmentPerformance Content (Why Choose Us - now "Introducing Our Expert Data Science Team")
    whyUsContent: {
        heading: "Introducing Our Expert Data Science Team",
        greenHeading: "Our Specialized",
        content: "Our specialized Data Scientists and Engineers manage every stage, from data collection and model development to deployment and real-time analytics, delivering scalable solutions that turn data into actionable insights and drive business growth.",
        stats: [
            {
                title: "Data Science Services Since",
                number: "2015",
            },
            {
                title: "Data Analytics Success Stories",
                number: "120+",
            },
            {
                title: "Certified Data Scientists & Engineers",
                number: "85+",
            },
            {
                title: "Industries Served with Data Solutions",
                number: "14+",
            },
        ],
        cta: {
            text: "Connect with Our Data Experts Today", // Adjusted based on new CTA
            link: "/contact-us",
        }
    },

    // mlSolutionsData (from "Machine Learning Solutions We Build" - repurposed for solving ML/Data challenges)
    mlSolutionsData: [
        {
            title: "Access to Pre-Vetted ML Talent", // Retained original title
            description:
                "We provide access to a network of 500+ rigorously tested ML engineers, data scientists, and MLOps specialists. Each expert is vetted for coding proficiency, domain expertise, and production experience, ensuring that you engage top-tier talent who can deliver immediate value.",
        },
        {
            title: "Rapid Onboarding & Seamless Integration", // Retained original title
            description:
                "Our engineers integrate into your team within 48 hours. We align time zones, reporting methods, and delivery cycles, ensuring smooth collaboration and eliminating onboarding delays from day one, accelerating time-to-market.",
        },
        {
            title: "End-to-End MLOps Implementation", // Retained original title
            description:
                "We optimize your ML workflows by implementing CI/CD pipelines for model training, deployment, and monitoring. This reduces manual workloads by up to 30% and accelerates model iteration cycles by 50%, leading to faster deployment and improved production performance.",
        },
        {
            title: "Scalable Infrastructure & Cloud Optimization", // Retained original title
            description:
                "We optimize your ML infrastructure to efficiently handle large-scale workloads, saving up to 40% in cloud costs by configuring cost-efficient environments on AWS, Azure, and GCP. Our engineers automate scaling to ensure resources are aligned with your business needs, preventing overruns.",
        },
        {
            title: "Robust Security & Compliance", // Retained original title
            description:
                "We ensure 100% compliance with ISO, SOC 2, and GDPR standards. All projects are initiated under a strict NDA, and we maintain audit-ready documentation throughout the ML lifecycle, ensuring data protection and regulatory compliance.",
        },
        {
            title: "Continuous Delivery & Measurable Results", // Retained original title
            description:
                "We monitor deployed models in real-time, performing performance retraining as needed. This improves model efficiency by 20% and ensures that your ML systems remain relevant and continue to deliver measurable ROI.",
        },
    ],

    // HireCombinationSection Content (from "Powerful Technology Combinations Our Data Experts Use")
    techCombinations: {
        shortHeading: "Powerful Technology Combinations Our Data Experts Use",
        heading: "Top Data Science & Engineering Tech Stacks for Scalable Analytics",
        description: "We combine cutting-edge data frameworks and tools to build secure, high-performance, and future-ready systems. Each technology combination is selected for speed, scalability, and accuracy, delivering measurable business insights.",
        combinations: [
            {
                title: "Python + Pandas + NumPy",
                description:
                    "Perfect for data cleaning, manipulation, and analysis enabling fast, efficient exploration and transformation.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "pandas.svg", altText: "Pandas data analysis library" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "SQL + Snowflake + AWS Redshift",
                description:
                    "A powerful trio for building scalable cloud-based data warehouses with high performance and cost efficiency.",
                icons: [
                    { icon: "sq-lite.svg", altText: "SQL language" }, // Placeholder icon/alt text
                    { icon: "snowflake.svg", altText: "Snowflake data platform" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Apache Spark + Hadoop + Kafka",
                description:
                    "Best for real-time big data processing, stream handling, and distributed computation across large datasets.",
                icons: [
                    { icon: "apache-spark.png", altText: "Apache Spark" }, // Placeholder icon/alt text
                    { icon: "hadoop.svg", altText: "Apache Hadoop" }, // Placeholder icon/alt text
                    { icon: "kafka.svg", altText: "Apache Spark" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Tableau + Power BI + Google Data Studio",
                description:
                    "Turn raw data into dynamic visual dashboards, enabling executives to make quick, data-backed decisions.",
                icons: [
                    { icon: "tableau.png", altText: "Tableau" }, // Placeholder icon/alt text
                    { icon: "powerbi.png", altText: "Power BI" }, // Placeholder icon/alt text
                    { icon: "gooogle-data-studio.png", altText: "Google Data Studio" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Airflow + DBT + Looker",
                description:
                    "Automate data workflows, transformations, and analytics pipelines for streamlined and reproducible reporting.",
                icons: [
                    { icon: "airflow.png", altText: "Apache Airflow" }, // Placeholder icon/alt text
                    { icon: "dbt.png", altText: "DBT" }, // Placeholder icon/alt text
                    { icon: "looker-icon.svg", altText: "DBT" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Python + TensorFlow + Scikit-learn",
                description:
                    "Combine data science and machine learning to power predictive models that enhance business forecasting.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "tensorflow.svg", altText: "TensorFlow deep learning framework" },
                ],
            },
            {
                title: "AWS Glue + S3 + Athena",
                description:
                    "Enable seamless data storage, ETL processing, and query execution in the cloud with minimal maintenance.",
                icons: [
                    { icon: "aws-glue.png", altText: "AWS Glue" }, // Placeholder icon/alt text
                    { icon: "aws.svg", altText: "AWS Glue" }, // Placeholder icon/alt text
                    { icon: "aws-s3.png", altText: "AWS S3" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Azure Synapse + Databricks + Power BI",
                description:
                    "Build enterprise-grade analytics pipelines on Azure for hybrid or multi-cloud environments.",
                icons: [
                    { icon: "azure.svg", altText: "Azure Synapse" }, // Placeholder icon/alt text
                    { icon: "databricks.png", altText: "Databricks" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "ElasticSearch + Kibana + Logstash (ELK)",
                description:
                    "Monitor, analyze, and visualize large-scale data streams for performance and operational insights.",
                icons: [
                    { icon: "elasticsearch.svg", altText: "ElasticSearch" }, // Placeholder icon/alt text
                    { icon: "kibana.svg", altText: "Kibana" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Python + LangChain + OpenAI GPT-3",
                description:
                    "Combine data science with advanced language models to build NLP-driven applications for predictive analytics, summarization, and decision-making support.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "langchain.png", altText: "LangChain LLM framework" },
                ],
            },
            {
                title: "Python + LangFuse + TensorFlow",
                description:
                    "Use LangFuse to stream real-time data and TensorFlow for predictive analytics, powering intelligent applications with continuous insights and context-aware interactions.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "langfuse.png", altText: "LangFuse AI monitoring tool" },
                ],
            },
            {
                title: "Python + Spark + Databricks",
                description:
                    "Leverage Apache Spark with Databricks to build fast, scalable data processing pipelines, enabling large-scale data processing and machine learning applications.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "apache.svg", altText: "Apache Spark data processing framework" },
                ],
            },
            {
                title: "AWS Lambda + Terraform + Docker",
                description:
                    "Automate serverless infrastructure with AWS Lambda, manage resources with Terraform, and containerize applications using Docker for highly scalable and cost-efficient deployments.",
                icons: [
                    { icon: "aws-lambda.svg", altText: "AWS Lambda" }, // Placeholder icon/alt text
                    { icon: "terraform.png", altText: "Terraform" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Google BigQuery + Dataflow + Looker",
                description:
                    "Use Google BigQuery for fast data querying, Dataflow for stream and batch data processing, and Looker to create advanced data visualizations that accelerate business insights.",
                icons: [
                    { icon: "google-cloud.svg", altText: "Google BigQuery" }, // Placeholder icon/alt text
                    { icon: "dataflow.svg", altText: "Google Dataflow" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Kubernetes + Docker + AWS Fargate",
                description:
                    "Containerize applications using Docker, orchestrate with Kubernetes, and use AWS Fargate to run applications without managing servers reducing overhead and boosting scalability.",
                icons: [
                    { icon: "kubernetes.svg", altText: "Kubernetes" }, // Placeholder icon/alt text
                    { icon: "docker.svg", altText: "Docker" }, // Placeholder icon/alt text
                ],
            },
            {
                title: "Python + PyTorch + Hugging Face Transformers",
                description:
                    "Integrate deep learning models with Hugging Face and PyTorch to deliver state-of-the-art NLP applications, such as chatbots, summarization tools, and language understanding models.",
                icons: [
                    { icon: "python.svg", altText: "Python programming language" },
                    { icon: "pytorch.svg", altText: "PyTorch deep learning library" },
                ],
            },
            {
                title: "Apache Kafka + Apache Flink + Cassandra",
                description:
                    "For real-time stream processing and high-volume data management, use Apache Kafka for data streaming, Flink for real-time analytics, and Cassandra for distributed database management.",
                icons: [
                    { icon: "kafka.svg", altText: "Apache Kafka" }, // Placeholder icon/alt text
                    { icon: "flink.png", altText: "Apache Flink" }, // Placeholder icon/alt text
                ],
            },
        ]
    },

    // whyChooseBitsclanContet (from "How We Work")
    whyChooseBitsclanContet: [
        {
            id: "Tab1",
            label: "Vetted Senior Data Talent",
            content:
                "Only the top 1% of applicants pass our rigorous assessments in data modeling, machine learning, and data engineering. Our engineers have proven expertise in building and maintaining enterprise-grade data environments that deliver tangible business value.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab2",
            label: "Timezone-Aligned Collaboration",
            content:
                "Our teams work within your time zone, joining standups, sprint planning, and reviews in real-time. This ensures quick feedback, faster iteration, and seamless collaboration without communication barriers.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab3",
            label: "Proficient in Communication",
            content:
                "Every engineer is fluent in English and skilled at explaining complex data science and engineering concepts to both technical and business stakeholders, ensuring alignment across departments and driving actionable outcomes.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab4",
            label: "Full-Stack Data Science & Engineering Capabilities",
            content:
                "From data pipelines and machine learning models to data visualization and cloud solutions, our engineers manage the entire data lifecycle, ensuring systems are secure, scalable, and optimized for continuous delivery of insights.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab5",
            label: "Scalable Teams",
            content:
                "New engineers can onboard within days, whether you’re expanding an existing team or launching a new data science initiative. Our flexible engagement models scale seamlessly as your project evolves.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab6",
            label: "Standard MSAs & SOWs",
            content:
                "We streamline onboarding with globally recognized contracts and compliance frameworks. Our MSAs and SOWs ensure enterprise transparency and alignment from day one.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab7",
            label: "NDA & IP Protection",
            content:
                "Security is core to every engagement. Strict NDAs, role-based access, and data governance protocols safeguard your data models, pipelines, and proprietary workflows.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab8",
            label: "Enterprise-Grade Security",
            content:
                "All data science operations comply with global standards like ISO 27001, SOC 2, and GDPR. We enforce secure data practices, encrypted communication, and continuous compliance monitoring.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
        {
            id: "Tab9",
            label: "Managed Delivery",
            content:
                "Every project is led by experienced delivery managers who monitor progress, resolve roadblocks, and ensure performance SLAs are met. Every deliverable is tracked and optimized for speed, stability, and measurable success.",
            btnText: "Contact Our Experts",
            btnLink: "/contact-us",
        },
    ],

    // engagementModels (from "Customized DevOps Solutions for Business Growth")
    engagementModels: {
        shortHeading: "Engagement Models",
        heading: "Customized DevOps Solutions for Business Growth",
        subheading: "Need DevOps expertise? Integrate us wherever you need us most. We tailor every engagement to fit your workflow, infrastructure, and delivery goals whether you’re scaling your operations team, automating deployments, or optimizing cloud infrastructure.",
        models: [
            {
                icon: "/images/engagement-model-gifs/hourly-icon.svg",
                index: 1,
                iconWidth: 40,
                title: "Flexible DevOps Expertise On-Demand",
                description: "Need additional DevOps engineers for specific projects or ongoing support? Quickly scale your operations with pre-vetted DevOps experts skilled in CI/CD automation, container orchestration, and cloud infrastructure all without the delays or overhead of traditional recruitment processes.",
            },
            {
                icon: "/images/engagement-model-gifs/price-icon.svg",
                index: 2,
                iconWidth: 35,
                title: "Dedicated Teams",
                description: "Need a full DevOps team to manage complex cloud or automation projects? We assemble dedicated teams focused solely on your business objectives, handling everything from infrastructure provisioning and pipeline setup to monitoring and system optimization.",
            },
        ],
        cta: {
            text: "Talent on Your Terms",
            button: "Accelerate with Data Science",
            link: "/contact-us",
        },
    },

    // HirePageSteps Content (from "How to Engage Data Scientists & Engineers in 3 Simple Steps")
    hireSteps: {
        btnText: "Ready to Turn Data into Your Competitive Advantage?",
        heading: "How to Engage Data Scientists & Engineers in 3 Simple Steps",
        steps: [
            {
                title: "Connect with Our Data Experts",
                description:
                    "Speak with our data science consultants to discuss your goals, existing infrastructure, and analytics challenges. We’ll assess your needs and recommend the right data experts to accelerate your data initiatives.",
                icon: "/images/hire-page-setps-icons/icon-1.svg",
            },
            {
                title: "Get Matched with Pre-Vetted Talent",
                description:
                    "Within 24–48 hours, we’ll connect you with top-tier Data Scientists and Engineers who align with your project’s requirements from predictive modeling to big data engineering. Each candidate is rigorously vetted for technical proficiency and analytical expertise.",
                icon: "/images/hire-page-setps-icons/icon-2.svg",
            },
            {
                title: "The Right Fit, Guaranteed",
                description:
                    "Start working with your new data expert under a risk-free trial. If you're not completely satisfied, we’ll provide a replacement at no additional cost ensuring the perfect fit for your team and workflow.",
                icon: "/images/hire-page-setps-icons/icon-3.svg",
            },
        ],
    },

    // CoverTheStack Content (from "Comprehensive Machine Learning Expertise")
    coverTheStack: {
        whereStart: "Data Stack", // Adjusted for data focus
        mainHeading: "Comprehensive Machine Learning Expertise",
        subHeading: "Our engineers utilize a modern tech stack designed for scalability, performance, and real-world impact. With hands-on experience across 100+ tools and frameworks, we provide end-to-end ML solutions from data engineering and model development to deployment, monitoring, and continuous optimization.",
        tabs: [
            "Languages & Frameworks", // Adjusted tabs
            "Cloud & Platforms",
            "Databases & Tools",
        ],
        tabItems: [
            { tab: "Languages & Frameworks", icon: "/images/tech-stack-icons/python.svg", name: "Python" },
            // { tab: "Languages & Frameworks", name: "R", icon: "/images/tech-stack-icons/r.svg", }, // Placeholder icon
            { tab: "Languages & Frameworks", name: "SQL", icon: "/images/tech-stack-icons/sql.png", }, // Placeholder icon
            { tab: "Cloud & Platforms", icon: "/images/cloud3.png", name: "AWS" },
            { tab: "Cloud & Platforms", name: "Google Cloud", icon: "/images/cloud1.png", },
            { tab: "Cloud & Platforms", name: "Azure", icon: "/images/azure.svg", }, // Placeholder icon
            { tab: "Databases & Tools", name: "Spark", icon: "/images/tech-stack-icons/apache.svg", },
            { tab: "Databases & Tools", icon: "/images/db7.png", name: "PostgreSQL" }, // Adjusted name
            { tab: "Databases & Tools", icon: "/images/db1.png", name: "Snowflake" }, // Adjusted name
        ],
    },

    // challengesData (from "Top Challenges in Data Hiring & Development")
    challengesData: [
        {
            title: "Finding Skilled Data Science Talent",
            description:
                "The demand for experienced data scientists far exceeds supply. Many candidates possess academic knowledge, but lack the hands on experience required to build, deploy, and maintain real-world data systems that provide actionable business insights.",
        },
        {
            title: "Lengthy Onboarding & Evaluation Process",
            description:
                "Screening data science candidates is a complex and time consuming process. Evaluating their expertise in data modeling, coding proficiency, and statistical analysis can take months, delaying data driven initiatives and innovation cycles.",
        },
        {
            title: "Cost Overruns & Inefficient Data Infrastructure",
            description:
                "Inefficient data processing cycles, unoptimized compute resources, and a lack of automation often lead to escalating cloud costs especially when large datasets or retraining models are involved. These inefficiencies affect both project budgets and timelines.",
        },
        {
            title: "Communication Gaps Between Teams",
            description:
                "Bridging the gap between technical data scientists and non-technical stakeholders can be challenging. Misalignment in objectives or performance metrics often leads to delays, rework, and a reduced ROI from data science initiatives.",
        },
    ],

    // expertFacts (Placeholder for a "Facts" section, reusing old data structure)
    expertFacts: {
        btnText: "schedule a Call",
        heading: "Why Hire Data Scientists & Engineers with",
        greenHeading: "Bitsclan?",
        facts: [
            { text: "We connect you with data experts who transform raw information into strategic value. Our teams combine technical excellence with business insight helping you make faster, smarter, and more confident decisions." },
            { text: "<strong>2015:</strong> Data Science Services Since" },
            { text: "<strong>120+:</strong> Data Analytics Success Stories" },
            { text: "<strong>85+:</strong> Certified Data Scientists & Engineers" },
            { text: "<strong>14+:</strong> Industries Served with Data Solutions" },
            { text: "We handle everything from ingestion, cleaning, and modeling to visualization, monitoring, and maintenance." },
        ],
        backgroundImage: `url(/images/hire-page-images/hire-data-science.avif)`, // Placeholder, adjusted image name
    },

    // HirePageAppIdea Content (from Case Study section)
    appIdeaSection: {
        heading: "Our Clients' Journey: Transforming Data into Business Growth with Data Science Solutions",
        content: "Explore how our Data Scientists and Engineers help businesses turn complex data into actionable insights, optimize workflows, and drive predictive modeling and real-time analytics, resulting in enhanced performance and measurable business outcomes across industries.",
    },

    // HirePageEngagementModels Component Props (FAQs)
    hirePageEngagementModels: {
        btnText: "schedule a Call",
        headingContent: [
            { text: "Frequently Asked" },
            { text: "Questions" },
        ],
        discription: "Find fast answers to common questions about engaging our world-class Data Scientists and Engineers.",
        hiringDetails: [
            {
                text: "How do I hire data scientists and engineers?",
                content: "We evaluate candidates based on technical skills, domain experience, and business understanding. Our network includes professionals experienced in analytics, ML, and data architecture for production environments.",
                icon: "question.svg", // Placeholder icon
            },
            {
                text: "How long does it take to build a data pipeline?",
                content: "A standard data pipeline can take 2–4 weeks, while larger projects with complex transformations or integrations may take 6–8 weeks to complete.",
                icon: "question.svg", // Placeholder icon
            },
            {
                text: "What tools and technologies do your data engineers use?",
                content: "Our teams work with Python, SQL, Spark, Hadoop, AWS, Azure, GCP, Airflow, DBT, and Power BI, among others selecting the best stack for your business case.",
                icon: "question.svg", // Placeholder icon
            },
            {
                text: "Can you manage the entire data lifecycle?",
                content: "Yes. We handle everything from ingestion, cleaning, and modeling to visualization, monitoring, and maintenance.",
                icon: "question.svg", // Placeholder icon
            },
            {
                text: "Can I hire data experts for short-term projects?",
                content: "Absolutely. We offer hourly, part-time, and full-time models with the flexibility to scale up or down based on workload.",
                icon: "question.svg", // Placeholder icon
            },
            {
                text: "Do you ensure data security and compliance?",
                content: "Yes. All data operations follow GDPR, ISO, and SOC 2 standards, ensuring encryption, secure access, and full compliance.",
                icon: "question.svg", // Placeholder icon
            },
            {
                text: "How quickly can I start working with a data scientist?",
                content: "We can match you with qualified candidates within 48 hours, ready to integrate into your systems and start contributing immediately.",
                icon: "question.svg", // Placeholder icon
            },
        ],
        // Adding the final CTA text from the prompt
        finalCta: {
            text: "Ready to Turn Data into Your Competitive Advantage?",
            subText: "Hire world-class Data Scientists and Engineers to design, build, and optimize your data systems powering smarter business decisions.",
            buttonText: "schedule a Call",
            link: "/contact-us",
        }
    }
}